import React, { useState, useEffect } from 'react'
import { Button, Divider, Row, Col, Form, Spin, Table } from 'antd'
import IntlMessages from '../../../util/IntlMessages'
import ds from '../../../Services/DataServices'
import { useHistory } from 'react-router-dom'
import { useDispatch, useStore, useSelector } from 'react-redux'
import { loadClosedRegData } from '../../../appRedux/actions/Sell'
import InfoToPrint from '../../../components/InfoToPrint'
import { loadOpenClosePaySummary } from '../../../appRedux/actions/CommonData'
import { OPEN_CLOSE } from '../../../constants/Pages'
import { setCommonConfigs } from '../../../appRedux/actions/CommonData'
import ExpandView from './ExpandView'
import { formatDigits } from '../../../appRedux/actions'
import { checkIsWeb } from '../../../appRedux/actions/MobAppFn'

const RegClosedListing = props => {
  const cashManageID = props.cashManageID
  const history = useHistory()
  const store = useStore()
  const [form] = Form.useForm()
  const dispatch = useDispatch()

  const getReduxClosedRegData = useSelector(
    ({ Sell }) => Sell.opencloseRegClosedData
  )
  const getReduxClosedRegLoading = useSelector(
    ({ Sell }) => Sell.openCloseRegClosedLoading
  )
  const getReduxDataSource = useSelector(
    ({ commonConfigs }) => commonConfigs.getPaySummary
  )
  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )
  const getDecimalPlaces = useSelector(
    ({ MainSale }) => MainSale.getDefaultDecimalPlaces
  )

  const [getCashTableData, setCashTableData] = useState([])
  const [getExpectedTotal, setExpectedTotal] = React.useState(0)
  const [getCountedValue, setCountedValue] = React.useState(0)
  const [getDifferenceValue, setDifferenceValue] = React.useState(0)
  const [getTotalColor, setTotalColor] = React.useState('rgb(215, 113, 115)')
  const [isLoadingTable, setIsLoadingTable] = React.useState(false)
  const [getCurrSymbol, setCurrSymbol] = useState('')
  const [getPagination, setPagination] = React.useState({
    CashManagementID: '',
    CurrentPageNo: 1,
    PageSize: 10,
    showSizeChanger: true
  })

  //Curr
  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      let commonData = getReduxCommonSetting
      if (
        commonData &&
        commonData.storeCommonConfigs &&
        commonData.storeCommonConfigs.storeConfig &&
        commonData.storeCommonConfigs.storeConfig.currencyData
      ) {
        let currencyData =
          commonData.storeCommonConfigs.storeConfig.currencyData
        setCurrSymbol(currencyData.currencySymbol)
        // setShortCurr(currencyData.currencyCode);
        // setCurrData(currencyData);
      }
    }

    return () => (mounted = false)
  }, [getReduxCommonSetting])

  React.useEffect(() => {
    dispatch(setCommonConfigs(OPEN_CLOSE))
    //cashmanagement id
    let cashmanageId = cashManageID
    let outletID =
      localStorage.getItem('selectedOut') &&
      JSON.parse(localStorage.getItem('selectedOut')).id
        ? JSON.parse(localStorage.getItem('selectedOut')).id
        : ''
    if (cashmanageId) {
      // let body = getPagination;
      // body.CashManagementID = cashmanageId;
      // setPagination(body);
      // getCashListingService(body);

      let closedInfoBody = {
        CashManagementID: cashmanageId
      }
      dispatch(loadClosedRegData(closedInfoBody, false))

      if (
        getReduxDataSource &&
        getReduxDataSource.length == 0 &&
        outletID != ''
      ) {
        let body = {
          CMID: cashmanageId,
          OutID: outletID,
          IsClosed: true
        }
        dispatch(loadOpenClosePaySummary(body))
      }
    }
  }, [])

  React.useEffect(() => {
    if (getReduxDataSource && getReduxDataSource.length > 0) {
      let expectedTotal = 0
      let totalCounted = 0
      // getReduxDataSource.map((e) => {
      //   if (e.isPrimary) {
      //     expectedTotal =
      //       getReduxClosedRegData &&
      //         getReduxClosedRegData.outletRegister &&
      //         getReduxClosedRegData.outletRegister.expected
      //         ? getReduxClosedRegData.outletRegister.expected + e.expected
      //         : 0;
      //   } else {
      //     if (e.paymentTypes != "LOYALTY") {
      //       expectedTotal = expectedTotal + e.expected;
      //     }
      //   }
      // });
      getReduxDataSource.map(e => {
        if (e.paymentTypes !== 'Totals') {
          expectedTotal += e.expected
        }
      })
      getReduxDataSource &&
        getReduxDataSource.length > 0 &&
        getReduxDataSource
          .filter(zz => zz.paymentTypes != 'Totals')
          .map(x => {
            totalCounted =
              x.counted && x.counted > 0
                ? totalCounted + x.counted
                : totalCounted
            // ? formatDigits(totalCounted + x.counted, getDecimalPlaces)
            // : totalCounted;
          })
      setExpectedTotal(
        expectedTotal ? formatDigits(expectedTotal, getDecimalPlaces) : '0.00'
      )
      const diffTotal = formatDigits(
        totalCounted - expectedTotal,
        getDecimalPlaces
      )
      setDifferenceValue(diffTotal)
    }
  }, [getReduxDataSource, getReduxClosedRegData])

  const columns = [
    {
      title: <IntlMessages id='sell.openclose.col1' />,
      width: 300,
      dataIndex: 'paymentTypes',
      key: 'paymentTypes',
      render: (text, record) => {
        return (
          <div>
            <strong>
              {text}
              {/* <IntlMessages id="sell.openclose.cash" /> */}
            </strong>
            {record.isPrimary && (
              <p className='gx-link' style={{ width: '50%' }}>
                <IntlMessages id='sell.openclose.col1desc' />
              </p>
            )}

            {/* {text == "Loyalty" && (
              <strong>
                <IntlMessages id="sell.openclose.loyalty" />
              </strong>
            )}
            {text == "Other Payment Method" && (
              <strong>
                <IntlMessages id="sell.openclose.otherpay" />
              </strong>
            )}
            {text == "Store Credit" && (
              <strong>
                <IntlMessages id="sell.openclose.storecredit" />
              </strong>
            )}
            {text == "Total" && (
              <strong>
                <IntlMessages id="sell.openclose.total" />
              </strong>
            )} */}
          </div>
        )
      }
    },
    {
      title: <IntlMessages id='sell.openclose.col2' />,
      dataIndex: 'expected',
      key: 'expected',
      render: (text, record) => {
        let expected = 0
        if (record.isPrimary) {
          expected =
            getReduxClosedRegData &&
            getReduxClosedRegData.outletRegister &&
            getReduxClosedRegData.outletRegister.expected
              ? formatDigits(
                  getReduxClosedRegData.outletRegister.expected + text,
                  getDecimalPlaces
                )
              : 0
        }
        return (
          <div>
            {record.isPrimary ? (
              <>
                <strong>
                  {text}
                  {/* {expected} */}
                  {getCurrSymbol}
                </strong>
              </>
            ) : record.paymentTypes == 'Totals' ? (
              <div>
                <h3>
                  <strong>
                    {getExpectedTotal
                      ? formatDigits(getExpectedTotal, getDecimalPlaces)
                      : '0.00'}
                    {getCurrSymbol}
                  </strong>
                </h3>
              </div>
            ) : (
              <>
                <strong>
                  {text ? formatDigits(text, getDecimalPlaces) : '0.00'}
                  {getCurrSymbol}
                </strong>
              </>
            )}
          </div>
        )
      }
    },
    {
      title: <IntlMessages id='sell.openclose.col3' />,
      dataIndex: 'counted',
      width: 200,
      key: 'counted',
      render: (text, record) => {
        let IsShow =
          record.expected > 0 &&
          record.paymentTypes != 'LOYALTY' &&
          record.paymentTypes != 'STORE_CREDIT' &&
          record.paymentTypes != 'Totals'
            ? true
            : record.isPrimary
            ? true
            : false

        let totalCounted = 0

        getReduxDataSource &&
          getReduxDataSource.length > 0 &&
          getReduxDataSource
            .filter(df => df.paymentTypes != 'Totals')
            .map(x => {
              totalCounted =
                x.counted && x.counted > 0
                  ? totalCounted + x.counted
                  : totalCounted
              // ? formatDigits(totalCounted + x.counted, getDecimalPlaces)
              // : totalCounted;
            })

        let totalCountedColor =
          totalCounted > getExpectedTotal ? '#41af4b' : 'rgb(215, 113, 115)'

        return (
          <div>
            {record.paymentTypes != 'Totals' && IsShow && (
              <div>
                <strong>
                  {text ? formatDigits(text, getDecimalPlaces) : '0.00'}
                  {getCurrSymbol}
                </strong>
              </div>
            )}

            {record.paymentTypes == 'Totals' && (
              <div>
                <h3 style={{ color: totalCountedColor }}>
                  <strong>
                    {totalCounted
                      ? formatDigits(totalCounted, getDecimalPlaces)
                      : '0.00'}
                    {getCurrSymbol}
                  </strong>
                </h3>
              </div>
            )}
          </div>
        )
      }
    },
    {
      title: <IntlMessages id='sell.openclose.col4' />,
      key: 'differences',
      dataIndex: 'differences',
      render: (text, record) => {
        let difference = formatDigits(
          record.counted - record.expected,
          getDecimalPlaces
        )
        return (
          <div>
            {record.paymentTypes != 'Totals' &&
              record.paymentTypes != 'STORE_CREDIT' &&
              record.paymentTypes != 'LOYALTY' && (
                <div>
                  {difference != '' && (
                    <strong
                      style={{
                        // marginTop: 26,
                        color:
                          difference && difference < 0
                            ? 'rgb(215, 113, 115)'
                            : '#41af4b'
                      }}
                    >
                      {difference}
                      {getCurrSymbol}
                    </strong>
                  )}
                </div>
              )}

            {record.paymentTypes == 'Totals' && <div>{getDifferenceValue}</div>}
          </div>
        )
      }
    }
  ]

  return (
   
      <Spin
        tip={<IntlMessages id='sell.cashlisting.cashloading' />}
        spinning={getReduxClosedRegLoading}
        size='large'
      >
        <Row className='mt-4 mb-4'>
          <Col span={6} md={6} xs={24}>
            <h2 className='custom-font-weight-500 custom-font-color-black'>
              <IntlMessages id='sell.openclose.regdetaillast' />
            </h2>
          </Col>

          <Col span={18} md={18} xs={24}>
            <div className='dk-last-closer-main'>
              <div className='dk-reg-closing'>
                <strong className='dk-reg-closing-flex'>
                  <IntlMessages id='sell.openclose.regdetail1' />
                </strong>
                <p>
                  {getReduxClosedRegData && getReduxClosedRegData.outletName
                    ? getReduxClosedRegData.outletName
                    : '---'}
                </p>
              </div>
              <div className='dk-reg-closing'>
                <strong className='dk-reg-closing-flex'>
                  <IntlMessages id='sell.openclose.regdetail2' />
                </strong>
                <p>
                  {getReduxClosedRegData &&
                  getReduxClosedRegData.outletRegister &&
                  getReduxClosedRegData.outletRegister.registerName
                    ? getReduxClosedRegData.outletRegister.registerName
                    : '---'}
                </p>
              </div>
              <div className='dk-reg-closing'>
                <strong className='dk-reg-closing-flex'>
                  <IntlMessages id='sell.openclose.regdetail3' />
                </strong>
                <p>
                  {getReduxClosedRegData &&
                  getReduxClosedRegData.outletRegister &&
                  getReduxClosedRegData.outletRegister.closure
                    ? getReduxClosedRegData.outletRegister.closure
                    : '1'}
                </p>
              </div>
              <div className='dk-reg-closing'>
                <strong className='dk-reg-closing-flex'>
                  <IntlMessages id='sell.openclose.regdetail4closingtime' />
                </strong>
                <p>
                  {getReduxClosedRegData &&
                  getReduxClosedRegData.outletRegister &&
                  getReduxClosedRegData.outletRegister.closedOnDate
                    ? getReduxClosedRegData.outletRegister.closedOnDate
                    : '---'}
                </p>
              </div>
            </div>
          </Col>
        </Row>

        <Divider className='custom-mgt-mgb-20' />

        <Row className='mt-4 mb-4'>
          <Col span={6} md={6} xs={24}>
            <h2 className='custom-font-weight-500 custom-font-color-black'>
              <IntlMessages id='sell.openclose.paymentsumry' />
            </h2>
            <p className='dk-font-size-12'>
              <IntlMessages id='sell.openclose.paymentsumry2' />
            </p>
          </Col>

          <Col span={18} md={18} xs={24}>
           <Spin
              tip={<IntlMessages id='sell.cashlisting.cashloading' />}
              spinning={
                getReduxClosedRegData && getReduxClosedRegData.outletRegister
                  ? false
                  : true
              }
              size='large'
            >
              <Table
                className='gx-table-responsive expanded-cashmove expanded-table-parent MinWidth-auto'
                columns={columns}
                dataSource={getReduxDataSource}
                loading={
                  getReduxDataSource && getReduxDataSource.length > 0
                    ? false
                    : true
                }
                expandable={{
                  expandedRowRender: record => (
                    <ExpandView
                      recPay={record.receivedPay}
                      // recPay={record.expected}
                      getCurrSymbol={getCurrSymbol}
                    />
                  ),
                  rowExpandable: record => record.isPrimary
                }}
                pagination={false}
                footer={false}
              />
            </Spin>
   
          </Col>
        </Row>

    

        {checkIsWeb().exist && (
          <Row>

<Col lg={24} md={24} sm={24} xs={24} className='text-right'>
              <Button
                className='dk-wd-auto'
                type='primary'
                onClick={() =>
                  history.push(
                    `/dashboard/reporting/registerclosures/summary/${cashManageID}`
                  )
                }
                size='large'
              >
                <IntlMessages id='sell.openclose.viewclosedetail' />
              </Button>
            </Col>
          </Row>
        )}
      </Spin>
  
  )
}

export default RegClosedListing
